import axios from 'axios';
import {
	API_SVC_HOST
} from '../config/common';
import _ from 'lodash';
import store from "@/state/store";
// import i18n from "@/i18n"
import { getAcceptLanguage } from '@/i18n'
import { showMessage } from '@/utils/hooks/message';
import { getLangValue } from "@/utils/common"; //获取后端语言
function urlFormat(url) {
	return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/" + _.trimStart(url, "/")
	// return url
}

// 创建axios实例 application/x-www-data-urlencoded;charset=UTF-8 application/json
var service = axios.create({
	baseURL: API_SVC_HOST,
	timeout: 300000,
	xhrFields: {
		withCredentials: true
	}
})

service.interceptors.request.use(
	reqConfig => {
		reqConfig.headers["Authorization"] = getToken()
		reqConfig.headers["Content-Type"] = "application/json"
		reqConfig.headers["Accept-Language"] = getAcceptLanguage()
		reqConfig.headers["timestamp"] = getTimestamp()
		// reqConfig.headers["Content-Encoding"]= "gzip";
		return reqConfig;
	},
	err => Promise.reject(err),
)

function getToken() {
	let storeData = store.state.login.menuList || sessionStorage.getItem('set_menu_list');
	if (storeData) {
		storeData = JSON.parse(storeData)
		return storeData.token
	}
	return ''
}

function getTimestamp() {
	// 获取时间戳
	let storeData = store.state.login.menuList || sessionStorage.getItem('set_menu_list');
	if (storeData) {
		storeData = JSON.parse(storeData)
		return storeData.timestamp
	}
	return ''
}

function request(url, params, options, type) {
	options = options || {}
	if (options && options.headers) {
		service.defaults.headers = Object.assign({}, service.defaults.headers, options.headers)
	}
	if (options && options.responseType) {
		// 设置response type 下载文件使用
		service.defaults.responseType = options.responseType
	}else{
		service.defaults.responseType = 'json'
	}
	return new Promise((resolve, reject) => {
		service[type](urlFormat(url, options), params).then((response) => {
			resolve(response.data)
		}).catch((err) => {
			// console.log(err);
			if (err && err.response && err.response.status == 403) {
				const data = {
					message: getLangValue('base.request403')
				}
				reject(data);
				// 跳转至登录页
				showMessage('warning', data.message)
				setTimeout(() => {
					window.location.href = '/'
				}, 3000);
			}else if (err && err.response && err.response.status == 422) {
				// console.log(err.response);
				// 跳转至登录页
				showMessage('danger', err.response.data.message.message)
			}else if (err && err.response && err.response.status == 404) {
				// 404
				showMessage('danger', 'server 404')
				reject(err);
			}
			else {
				showMessage('danger', err.response.data.message.message)
				if (err.response && err.response.data && err.response.data.message) {
					reject(err.response.data.message);
				} else {
					reject(err.response && err.response.data && err.response.data.payload || err);
				}
			}
		});
	});
}

function request1(url, params, options, type) {
	options = options || {}
	if (options && options.headers) {
		// 设置headers
		service.defaults.headers = Object.assign({}, service.defaults.headers, options.headers)
	}
	console.log(options);
	if (options && options.responseType) {
		// 设置response type 下载文件使用
		service.defaults.responseType = options.responseType
	}else{
		service.defaults.responseType = 'json'
	}
	return new Promise((resolve, reject) => {
		service[type](urlFormat(url, options), params).then((response) => {
			resolve(response)
		}).catch((err) => {
			if (err && err.response && err.response.status == 403) {
				const data = {
					message: getLangValue('base.request403')
				}
				reject(data);
				// 跳转至登录页
				showMessage('warning', data.message)
				setTimeout(() => {
					window.location.href = '/'
				}, 3000);
			} else {
				if (err.response && err.response.data && err.response.data.message) {
					reject(err.response.data.message);
				} else {
					reject(err.response && err.response.data && err.response.data.payload || err);
				}
			}
		});
	});
}

export function createAPI() {
	return {
		post(url, params, options) {
			return request(url, params, options, 'post');
		},
		get(url, params, options) {
			return request(url, {
				params
			}, options, 'get');
		},
		put(url, params, options) {
			params = Object.assign({}, params, {
				_method: 'PUT'
			});
			return request(url, params, options, 'put');
		},
		delete(url, params, options) {
			params = Object.assign({}, params, {
				_method: 'DELETE'
			});
			return request(url, {
				params
			}, options, 'delete');
		},
		upload(url, data, options) {
			return request1(url, data, options, 'post');
		},
		download(url, params, options) {
			return request1(url, {params}, options, 'get');
		}
	};
}
